module.exports = __webpack_public_path__ + "static/media/JP_RB_EYELASHES03.e4e2a910.jpg";